<div class="modal-header">
    <h5 class="modal-title">Detalhes do Parcelamento</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    @if (debt) {
        <!-- Identificação -->
        <div class="card mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted d-block">Nº Parcelamento</small>
                        <strong>{{ debt.installmentNumber }}</strong>
                    </div>
                    <div class="col-md-4">
                        <small class="text-muted d-block">Período</small>
                        <strong>{{ debt.monthInstallment }}</strong>
                    </div>
                    <div class="col-md-4">
                        <small class="text-muted d-block">Estado</small>
                        <strong>{{ debt.state }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <!-- Valores Principais -->
        <div class="row mb-3">
            <div class="col-md-6">
                <div class="card h-100">
                    <div class="card-body text-center">
                        <small class="text-muted d-block mb-2">Valor Consolidado</small>
                        <h4 class="mb-0">{{ debt.consolidatedValue | currency }}</h4>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card h-100 bg-light">
                    <div class="card-body">
                        <small class="text-muted d-block mb-2">Status</small>
                        <span [class]="getStatusBadgeClass(debt.negotiationStatus || '')">
                            {{ debt.negotiationStatus || '—' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Parcelas -->
        <div class="card mb-3">
            <div class="card-header">
                <h6 class="mb-0">Informações de Parcelas</h6>
            </div>
            <div class="card-body">
                <div class="row text-center">
                    <div class="col-3">
                        <h4 class="mb-0">{{ debt.totalInstallments || 0 }}</h4>
                        <small class="text-muted">Total</small>
                    </div>
                    <div class="col-3">
                        <h4 class="mb-0">{{ debt.totalInstallmentPaid || 0 }}</h4>
                        <small class="text-muted">Pagas</small>
                    </div>
                    <div class="col-3">
                        <h4 class="mb-0">{{ debt.totalInstallmentRemaining || 0 }}</h4>
                        <small class="text-muted">Restantes</small>
                    </div>
                    <div class="col-3">
                        <h4 class="mb-0 text-danger">{{ debt.overdueInstallments || 0 }}</h4>
                        <small class="text-muted">Em Atraso</small>
                    </div>
                </div>
            </div>
        </div>

        <!-- Valores Estimados -->
        <div class="card mb-3">
            <div class="card-header">
                <h6 class="mb-0">Valores Estimados</h6>
            </div>
            <div class="card-body">
                <table class="table table-sm mb-0">
                    <tbody>
                        <tr>
                            <td class="text-muted">Parcela Atual Estimada</td>
                            <td class="text-end"><strong>{{ debt.estimatedInstallmentValue | currency }}</strong></td>
                        </tr>
                        <tr>
                            <td class="text-muted">Saldo Devedor Estimado</td>
                            <td class="text-end"><strong>{{ debt.estimatedDebtValue | currency }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Composição Financeira -->
        <div class="card mb-3">
            <div class="card-header">
                <h6 class="mb-0">Composição do Valor</h6>
            </div>
            <div class="card-body">
                <table class="table table-sm mb-0">
                    <tbody>
                        <tr>
                            <td class="text-muted">Principal</td>
                            <td class="text-end"><strong>{{ debt.principalValue | currency }}</strong></td>
                        </tr>
                        <tr>
                            <td class="text-muted">Multa</td>
                            <td class="text-end"><strong>{{ debt.fineValue | currency }}</strong></td>
                        </tr>
                        <tr>
                            <td class="text-muted">Juros</td>
                            <td class="text-end"><strong>{{ debt.interestValue | currency }}</strong></td>
                        </tr>
                        <tr>
                            <td class="text-muted">Encargos</td>
                            <td class="text-end"><strong>{{ debt.chargesValue | currency }}</strong></td>
                        </tr>
                        <tr class="table-active">
                            <td><strong>Juros Acumulados</strong></td>
                            <td class="text-end"><strong>{{ debt.accumulatedInterestValue | currency }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Negociação -->
        <div class="card mb-0">
            <div class="card-header">
                <h6 class="mb-0">Negociação</h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-2">
                        <small class="text-muted d-block">Tipo</small>
                        <strong>{{ debt.negotiationType || '—' }}</strong>
                    </div>
                    <div class="col-md-6 mb-2">
                        <small class="text-muted d-block">Modalidade</small>
                        <strong>{{ debt.negotiationModality || '—' }}</strong>
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close()">
        Fechar
    </button>
</div>

